import { Component, OnInit } from '@angular/core';
import { Topbar } from '../../providers/topbar';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  public type: any;

  constructor(public topbar: Topbar) {}

  ngOnInit() {
    this.topbar.searching$.subscribe(searching => {
      if (searching) {
        this.topbar.getData().subscribe(data => {
          this.type = data;
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/search/search.component.ts